module.exports = __webpack_public_path__ + "img/scan.520a7bc5.svg";